import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-link-share',
  templateUrl: './link-share.component.html',
  styleUrl: './link-share.component.scss'
})
export class LinkShareComponent {
  @Input()
  public linkToBeShared: string = '';

  @Input()
  public title: string = ''

  constructor(private toastr: ToastrService){
  
  }
  public async shareLink(){
    if ('share' in navigator) {
      try {
        await navigator.share({
          url: this.linkToBeShared
        })
      } catch (e) {
        console.error(e);
        this.toastr.error("Something went wrong while sharing")
      }
    } else {
      this.toastr.info("Your browser doesn't support Share API")
    }

  }

  async copyLink(){
    try{ 
      await navigator.clipboard.writeText(this.linkToBeShared);
      this.toastr.success("Link successfully copied!")
    }catch(e){
      this.toastr.error("Error while copying link")
    }
    
  }


}
